import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import { dispatchSync, useReframe } from 'nike-re-framejs';

import TournamentList from '../components/TournamentList';
import Superkurzy from '../components/Superkurzy';
import { TodayOffer, TodayVisibleDates } from '@/nikeone/components/TodayOffer';
import OverviewLoader from './OverviewLoader';
import FilterSlider, { ResultsFilterSlider } from '../components/FilterSlider';
import SportSlider from '../components/sport-slider/SportSlider';
import NikeOneContext from '../context/NikeOneContext';
import FilterSliderFake from '../components/FilterSliderFake';
import FakeSportsSlider from '../components/sport-slider/FakeSportsSlider';
import Redirect from '@/routing/Redirect';
import { NIKE1, NIKE1_FAV, NIKE1_RESULTS } from '@/routing/routes';
import { setToday } from '@/nikeone/handlers';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';
import TurboLiveProvider from '@/turbo-live/context/TurboLiveProvider';
import { useScoreboardTypes } from 'nike-ui/src/components/turboLive/hooks/useScoreboardTypes';

const SPECIAL_SLUGS_MAP = {
    '/superkurzy': Superkurzy,
    '/dnes': TodayOffer
};

export function isSpecialSlug(slug) {
    return Object.keys(SPECIAL_SLUGS_MAP).includes(slug);
}

function shouldRevertSlug(slug, byDate) {
    return slug === '/dnes' && TodayVisibleDates.indexOf(byDate) < 0;
}

function OverviewContent({ selectedSlug, results }) {
    const { favoritesOnly } = useContext(NikeOneContext);
    const derefSub = useReframe();
    let slug = selectedSlug;
    useScoreboardTypes();

    const byDate = derefSub(['nikeone/filter/byDate']);
    if (shouldRevertSlug(slug, byDate)) {
        // return <PageRedirect route="::current" />;
        // TODAY je jedna velka sracka, toto riesi nejake bugy a nejake dalsie zrejme vytvara
        return <Redirect route={results ? NIKE1_RESULTS : favoritesOnly ? NIKE1_FAV : NIKE1} />;
    }
    const menuNotLoadedYet = derefSub(['nikeone.menuNotLoadedYet']);
    if (menuNotLoadedYet) {
        return (
            <>
                <FakeSportsSlider superkurzy todayOffer />
                <FilterSliderFake />
                <OverviewLoader delay={200} />
            </>
        );
    }
    if (!slug) {
        slug = derefSub(['nikeone.defaultSportSlug.filtered', favoritesOnly]) || '';
    }
    const Component = isSpecialSlug(slug) ? SPECIAL_SLUGS_MAP[slug] : TournamentList;

    return (
        <BetLocationContext.Provider value={{ betLocationSection: betLocation.KURZY_OVERVIEW_PREMATCH }}>
            <SportSlider slug={slug} results={results} />
            {results ? <ResultsFilterSlider slug={slug} /> : <FilterSlider slug={slug} />}

            <TurboLiveProvider>
                <ContentComponent slug={slug} component={Component} key={'today-' + (Component === TodayOffer)} />
            </TurboLiveProvider>
        </BetLocationContext.Provider>
    );
}

class ContentComponent extends React.Component {
    UNSAFE_componentWillMount() {
        const Component = this.props.component;
        dispatchSync(setToday(Component === TodayOffer));
    }
    render() {
        const Component = this.props.component;
        return <Component slug={this.props.slug} />;
    }
}

const Overview = memo(function Overview({ sportSlug, countrySlug, results }) {
    const slugs = [sportSlug, countrySlug].filter(Boolean);
    const selectedSlug = slugs.length > 0 ? '/' + slugs.join('/') : null;
    return <OverviewContent selectedSlug={selectedSlug} results={results} />;
});

Overview.propTypes = {
    sportSlug: PropTypes.string,
    countrySlug: PropTypes.string,
    results: PropTypes.bool
};

export default Overview;
